export default function () {
  var self = this;
  self.selectedResource = ko.observable();
}

